import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const H3Element = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  return (
    <h3 className="element-h3" style={style}>
      {replaceTemplates(element.text)}
    </h3>
  );
};

export default H3Element;

